import React, {useState} from "react";
import {toKSTISOString, toKSTISOStringEnd} from "../../../components/commonmethod/CommonMethod";
import {PageHeader} from "../../../components/PageHeader";
import {InspectionHeaderListType} from "./subPages/InspectionHeaderListType";
import {addYears} from "date-fns";
import useRequestData from "../../../hooks/useRequestData";
import {getInspectionHeaderList} from "../../../api/maintenance/InspectionService";

function InspectionHeaderList() {
    const [checked,setChecked] = useState([]);

    const initDate ={
        startDate:toKSTISOString(addYears(new Date(),-1)),
        endDate:toKSTISOStringEnd(addYears(new Date(),0)),
    }

    const { newData, pageInfo, dataHook} =
        useRequestData(getInspectionHeaderList, initDate, "inspection_header");

    return (
        <>
            <div className="common-container">
                <PageHeader header={`정기점검관리`} indicator={`유지보수업무 > 점검관리 > 정기점검계획관리`} />

                <InspectionHeaderListType
                    data={newData} date={initDate} pageInfo={pageInfo} dataHook={dataHook}
                    checked={{checked: checked, setChecked: setChecked}} />
            </div>
        </>
    );
}

export {InspectionHeaderList}